import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'

const ShowMore = ({ className, children, initialHeight, disabled }) => {
  const [height, setHeight] = useState(initialHeight)
  const containerRef = useRef(null)

  const handleToggle = (e) => {
    const { current } = containerRef
    e.preventDefault()
    if (height <= initialHeight) {
      return setHeight(current.scrollHeight)
    }
    return setHeight(initialHeight)
  }

  const containerStyle = {
    overflow: 'hidden',
    height: `${height}px`,
    transition: 'height .3s ease',
  }

  const renderName = () => {
    return height <= initialHeight ? (
      <>
        Show more <i className="fa fa-angle-down ml-1" aria-hidden="true"></i>
      </>
    ) : (
      <>
        Show less <i className="fa fa-angle-up ml-1" aria-hidden="true"></i>
      </>
    )
  }

  return (
    <div className={`show-more`}>
      <div className={`relative ${className}`} ref={containerRef} style={containerStyle}>
        {children}
        {!disabled && height === initialHeight && <div className="gradient-showmore"></div>}
      </div>
      {!disabled && (
        <button
          className="lato-reg text-base outline-0 text-primary-orange focus:outline-none"
          onClick={handleToggle}
        >
          {renderName()}
        </button>
      )}
    </div>
  )
}

ShowMore.propTypes = {
  children: PropTypes.node,
  initialHeight: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default ShowMore
